import { render, staticRenderFns } from "./inquiryDetails.vue?vue&type=template&id=444491b2&scoped=true"
import script from "./inquiryDetails.vue?vue&type=script&lang=js"
export * from "./inquiryDetails.vue?vue&type=script&lang=js"
import style0 from "./inquiryDetails.vue?vue&type=style&index=0&id=444491b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444491b2",
  null
  
)

export default component.exports